/**
 * sortByTimeFilter
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import sortBy from 'lodash-es/sortBy';

export function sortHourlyRateRangesFilter() {
    return function(ranges) {
        if (!ranges || ranges.length === 0) {
            return ranges;
        }

        return sortBy(ranges, ['day', 'start']);
    };
}
